import React from 'react';

const STAT_CATEGORIES = [
  'G',
  'A',
  'P',
  'PIM',
  'PPP',
  'SHP',
  'GWG',
  'SOG',
  'HIT',
  'BLK',
  'W',
  'SV%',
  'SHO',
];

const CategoryBadges = ({ player }) => {
  const badges = STAT_CATEGORIES.map((category) => ({
    category,
    level: player?.[`badge_${category}`],
  })).filter(({ level }) => level);

  if (badges.length === 0) return null;

  return (
    <span className="category-badges" aria-label="Projection category badges">
      {badges.map(({ category, level }) => (
        <span
          key={category}
          className={`category-badge category-badge-${String(level).toLowerCase()}`}
          title={`${category}: ${level}`}
        >
          {category}
        </span>
      ))}
    </span>
  );
};

export default CategoryBadges;
